import { call, put, takeEvery } from "redux-saga/effects";
import { LOAD_ANNUAL_FINALS } from "./actionTypes";
import { LoadAnnualFinals, loadAnnualFinalsFailed, loadAnnualFinalsSuccess } from "./actions";
import AnnualFinalsApi from "./api";

function* loadAnnualFinalsStep({ payload }: LoadAnnualFinals) {
    try {
        const annualFinals = yield call(AnnualFinalsApi.load, payload.year);

        yield put(loadAnnualFinalsSuccess({ annualFinals }));
    } catch (e) {
        yield put(loadAnnualFinalsFailed(e.message));
    }
}

export function* loadAnnualFinalsSaga() {
    yield takeEvery(LOAD_ANNUAL_FINALS, loadAnnualFinalsStep);
}
